export default __webpack_public_path__ + "static/media/green_right_arrow.b9e0843f.svg";